import { RepeatWrapping, TextureLoader, Vector2 } from 'three'

const FLOOR_COLOR = '#e0dcd6'

const configureFloorTexture = (texture: THREE.Texture) => {
  texture.wrapT = RepeatWrapping
  texture.wrapS = RepeatWrapping
  texture.repeat.set(100, 100)
}

const textureLoader = new TextureLoader()
const loadFloorTexture = (url: string) => {
  const absUrl = new URL(url, phoenix.runtimeConfig.RESOURCES_URL ?? '').href

  return textureLoader.load(absUrl, texture => {
    configureFloorTexture(texture)
  })
}

const floorMapTexture = loadFloorTexture('textures/Stone_Effect_Tiles_02_BaseColor.jpg')
const floorRoughnessTexture = loadFloorTexture('textures/Stone_Effect_Tiles_02_Roughness.jpg')
const floorNormalTexture = loadFloorTexture('textures/Stone_Effect_Tiles_02_Normal.jpg')
const floorAOTexture = loadFloorTexture('textures/Stone_Effect_Tiles_02_AmbientOcclusion.jpg')
const floorBumpTexture = loadFloorTexture('textures/Stone_Effect_Tiles_02_Height.jpg')

export const Floor = () => {
  return (
    <mesh position={[0, -1, 0]}>
      <boxGeometry args={[160000, 0.1, 160000]} />
      <meshStandardMaterial
        color={FLOOR_COLOR}
        map={floorMapTexture}
        roughness={1.5}
        roughnessMap={floorRoughnessTexture}
        normalMap={floorNormalTexture}
        aoMap={floorAOTexture}
        bumpMap={floorBumpTexture}
        normalScale={new Vector2(1, 1)}
      />
    </mesh>
  )
}
